import React from 'react';
import { Send, Play, Check, Pause } from 'lucide-react';

export interface CampaignStatCardsProps {
  totalCount: number;
  activeCount: number;
  completedCount: number;
  draftCount: number;
}

export const CampaignStatCards: React.FC<CampaignStatCardsProps> = ({
  totalCount,
  activeCount,
  completedCount,
  draftCount,
}) => {
  const cards = [
    {
      id: 'total',
      title: 'Total Campaigns',
      count: totalCount,
      subtext: 'All time',
      icon: Send,
      iconBg: 'bg-[#F3E8FF]',
      iconColor: 'text-[#A655F8]',
    },
    {
      id: 'active',
      title: 'Active Campaigns',
      count: activeCount,
      subtext: 'In progress',
      icon: Play,
      iconBg: 'bg-[#E0F2FE]',
      iconColor: 'text-[#0284C7]',
    },
    {
      id: 'completed',
      title: 'Completed',
      count: completedCount,
      subtext: 'This month',
      icon: Check,
      iconBg: 'bg-[#DCFCE7]',
      iconColor: 'text-[#16A34A]',
    },
    {
      id: 'draft',
      title: 'Draft',
      count: draftCount,
      subtext: 'Not started',
      icon: Pause,
      iconBg: 'bg-[#FFEDD5]',
      iconColor: 'text-[#EA580C]',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-3.5">
      {cards.map((card) => {
        const IconComponent = card.icon;
        return (
          <div
            key={card.id}
            className="bg-white rounded-xl border border-gray-200/80 p-5 shadow-sm flex items-center space-x-4 hover:border-gray-300 transition-all"
          >
            <div className={`w-12 h-12 rounded-full ${card.iconBg} flex items-center justify-center shrink-0`}>
              <IconComponent className={`w-5 h-5 ${card.iconColor}`} />
            </div>
            <div>
              <p className="text-xs font-medium text-gray-500">{card.title}</p>
              <h3 className="text-2xl font-bold text-gray-900 leading-tight my-0.5">
                {card.count}
              </h3>
              <p className="text-xs text-gray-400">{card.subtext}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
